<template>
  <div>
    <BlDialogMv
      :active="isActive"
      title="Setujui sistem pembayaran?"
      confirm-text="Setuju dan bayar sekarang"
      dismiss-text="Cek detail lagi"
      data-testid="confirm-purchase-dialog"
      @confirmClick="handleConfirmClick"
      @dismissClick="handleDismissClick"
    >
      <div slot="description">
        <BlTextAv class="mb-24">
          Biaya harian {{ money(dailyFee) }} untuk QRIS Soundbox
          {{ schemeName }} akan dipotong otomatis dari Saldo Mitra.
        </BlTextAv>
      </div>
    </BlDialogMv>
  </div>
</template>

<script>
import BlTextAv from '@bukalapak/bazaar-mweb/dist/components/BlTextAv';
import BlDialogMv from '@bukalapak/bazaar-mweb/dist/components/BlDialogMv';
import money from 'shared_js/helpers/stringHelper/money';

const TRACKER_SCREEN_NAME = 'item-mitra-purchase-confirmation-';

export default {
  name: 'PurchaseConfirmationDialog',
  components: {
    BlDialogMv,
    BlTextAv,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    schemeName: {
      type: String,
      default: '',
    },
    dailyFee: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    mitraItemId: {
      type: Number,
      default: null,
    },
  },
  watch: {
    isActive(newVal) {
      if (newVal) {
        this.visitScreenTrack();
      }
    },
  },
  methods: {
    money,
    handleConfirmClick() {
      if (!this.isLoading) {
        this.trackPurchaseConfirmationConfirm();
        this.$emit('confirm-clicked');
      }
    },
    handleDismissClick() {
      this.trackPurchaseConfirmationDismiss();
      this.$emit('dismiss-clicked');
    },
    trackPurchaseConfirmationConfirm() {
      if (this.$tracker && this.mitraItemId) {
        this.$tracker.itemMitraItemClickTrack({
          click_source:
            'click-item-mitra-checkout-purchase-confirmation-confirm',
          current_screen: `${TRACKER_SCREEN_NAME}${this.mitraItemId}`,
          target_screen: 'transaction_detail',
        });
      }
    },
    trackPurchaseConfirmationDismiss() {
      if (this.$tracker && this.mitraItemId) {
        this.$tracker.itemMitraItemClickTrack({
          click_source:
            'click-item-mitra-checkout-purchase-confirmation-dismiss',
          current_screen: `${TRACKER_SCREEN_NAME}${this.mitraItemId}`,
          target_screen: 'checkout_page',
        });
      }
    },
    visitScreenTrack() {
      if (this.$tracker && this.mitraItemId) {
        this.$tracker.itemMitraLandingPageVisitTrack({
          current_screen: `${TRACKER_SCREEN_NAME}${this.mitraItemId}`,
        });
      }
    },
  },
};
</script>
